import { Dispatch } from '@reduxjs/toolkit';
import { QueryClient } from 'react-query';
import { resetAmplitude } from 'src/analitycs';
import { resetSession } from 'src/redux/store';

interface ClearSessionStateParams {
  dispatch: Dispatch;
  queryClient: Pick<QueryClient, 'clear'>;
}

const runStep = (name: string, step: () => void) => {
  try {
    step();
  } catch {
    console.error(`clearSessionState: falló el paso ${name}`);
  }
};

export const clearSessionState = ({ dispatch, queryClient }: ClearSessionStateParams) => {
  runStep('resetSession', () => dispatch(resetSession()));
  runStep('queryClient.clear', () => queryClient.clear());
  runStep('resetAmplitude', () => resetAmplitude());
};
